import styled from 'styled-components';
import { isIE11 } from '../../../../helpers/utils-helpers';

export const HistoryDrawerSC = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;

  .hd-body {
    display: ${isIE11 ? 'block' : 'flex'};
    flex-direction: column;
    flex: 1;
    min-height: 100%;
    position: relative;
    overflow: hidden;

    .news2__more-info-section {
      > span {
        font-weight: 700;
      }

      ul {
        padding: 0;

        li {
          display: flex;
          justify-content: space-between;
          max-width: 90%;

          > span:not(:first-child) {
            width: 80px;
          }
        }
      }
    }

    .hd-body-content {
      display: flex;
      flex-grow: 1;
      position: relative;
    }

    .hd-body-list {
      width: 100%;
      height: 100%;
      position: absolute;
    }
  }

  .hd-body-bottom {
    margin-top: auto;
    background-color: white;
    z-index: 1;
  }

  .news2 {
    &__link-info {
      font-weight: bold;
      text-decoration: underline;
      cursor: pointer;
      color: white;
    }
  }
`;

export const HistoryItemSC = styled.div`
  display: flex;
  align-items: flex-start;
  flex-flow: row wrap;
  height: auto;
  padding-top: 8px;
  padding-left: 24px;
  padding-right: 24px;

  &:not(:last-of-type) {
    border-bottom: 1px solid rgba(215, 217, 226, 0.7);
  }

  .hi-chart-col {
    width: 60px;
    height: 47px;
  }

  .hi-content-col {
    flex: 1;
    font-weight: 600;
    line-height: 1.3;

    time {
      font-size: 16px;
    }

    div {
      font-size: 14px;
      color: rgba(24, 30, 52, 0.7);
    }
  }

  .hi-type-col {
    text-align: right;
    padding-bottom: 8px;
  }

  .hi-value-col {
    text-align: right;
    font-weight: 800;
    font-size: 18px;

    span {
      font-weight: 600;
      font-size: 12px;
    }
  }

  .news2-more-info {
    margin-top: 12px;

    > div {
      width: 100%;
      margin-top: 4px;
      margin-bottom: 4px;
      display: flex;
      justify-content: space-between;
    }
  }
`;
